import { useQuery } from "@apollo/client";
import {GET_ALL_CAMPAIGNS} from "../../../utils/api/campaign";
import HomeList from './HomeList';
import { CampaignStatus } from "../../../__generated__/graphql";


const ActiveList = () => {
  const {
    loading,
    error,
    data,
  } = useQuery(GET_ALL_CAMPAIGNS, {
    variables: {
      filters: {
        status: CampaignStatus.Active,
      },
      // sort: "CREATEDAT__UPDATEDAT_DESC",
      // limit: 10,
    },
  });

  const campaigns = data?.campaigns?.items || []

  return <HomeList campaigns={campaigns} loading={loading} error={error} />
};

export default ActiveList;
